import { render, staticRenderFns } from "./AdminsManager.vue?vue&type=template&id=c358e0d2&scoped=true&"
import script from "./AdminsManager.vue?vue&type=script&lang=js&"
export * from "./AdminsManager.vue?vue&type=script&lang=js&"
import style0 from "./AdminsManager.vue?vue&type=style&index=0&id=c358e0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c358e0d2",
  null
  
)

export default component.exports